@if (envBanner) {
  <div class="env-banner" [class.env-banner--staging]="envName === 'staging'">{{ envBanner }}</div>
}

<app-header></app-header>

<div class="main-content">
  <router-outlet />
</div>
<app-footer></app-footer>


<ngx-spinner bdColor="rgba(0,0,0,0.35)"
             size="medium"
             color="#fff"
             type="ball-spin-clockwise"
             [fullScreen]="true">
</ngx-spinner>
